import React from 'react';

type PotencyDividerProps = { potencyCopyLength: number };

export const PotencyDivider = ({ potencyCopyLength }: PotencyDividerProps): JSX.Element =>
  potencyCopyLength > 15 ? <br /> : <span> • </span>;
